// common/schemas/collections/environments.js
import { z } from "zod";

const EnvironmentSchema = z.object({
    _id: z.string().optional(),
    subscriptionId: z.string(),
    name: z.string().min(1, "Environment name is required."),
    description: z.string().optional().nullable(),
    visualBasePrompt: z.string().min(1, "Visual base prompt is required."),
    representativeImageRelativePath: z.string().optional().nullable(),
    assetHash: z.string().optional().nullable().describe("A unique hash for cache-busting the representative image."),
    ambientSoundRelativePath: z.string().optional().nullable(),
    isDirty: z.boolean().optional().default(false).describe("Set to true if the asset needs regeneration."), // ADD THIS LINE
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default EnvironmentSchema;